module.exports = __webpack_public_path__ + "static/media/04_plantilla_combo_rectangular_marco_comida_8.3d0e0504.png";